import Nav from "@/components/landing/Nav";
import PremiereBanner from "@/components/landing/PremiereBanner";
import Hero from "@/components/landing/Hero";
import Mission from "@/components/landing/Mission";
import Pillars from "@/components/landing/Pillars";
import Orchard from "@/components/landing/Orchard";
import NaturalBuilding from "@/components/landing/NaturalBuilding";
import Gallery from "@/components/landing/Gallery";
import Exchange from "@/components/landing/Exchange";
import ProofOfReserve from "@/components/landing/ProofOfReserve";
import Film from "@/components/landing/Film";
import Directors from "@/components/landing/Directors";
import Proof from "@/components/landing/Proof";
import Location from "@/components/landing/Location";
import Contact from "@/components/landing/Contact";
import SmsBanner from "@/components/landing/SmsBanner";
import Footer from "@/components/landing/Footer";
import ChatWidget from "@/components/landing/ChatWidget";

const Landing = () => {
  return (
    <div className="font-sans bg-stone-950 text-stone-100 min-h-screen selection:bg-amber-500 selection:text-black">
      <PremiereBanner />
      <Nav />
      <Hero />
      <Mission />
      <Pillars />
      <Orchard />
      <NaturalBuilding />
      <Gallery />
      <Exchange />
      <ProofOfReserve />
      <Film />
      <Directors />
      <Proof />
      <Location />
      <Contact />
      <SmsBanner />
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default Landing;
